var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import React, { Component } from 'react';
import { default as styled } from 'styled-components';
import classnames from 'classnames';
import { withSuomifiDefaultProps } from '../theme/utils';
import { baseStyles } from './Button.baseStyles';
import { Button as CompButton, } from '../../components/Button/Button';
import { Icon } from '../Icon/Icon';
import { UnstyledButton } from './UnstyledButton';
var baseClassName = 'fi-button';
var iconClassName = baseClassName + "_icon";
var iconRightClassName = baseClassName + "_icon--right";
var fullWidthClassName = baseClassName + "--fullwidth";
var StyledButton = styled(function (_a) {
    var tokens = _a.tokens, fullWidth = _a.fullWidth, _b = _a.variant, variant = _b === void 0 ? 'default' : _b, className = _a.className, passProps = __rest(_a, ["tokens", "fullWidth", "variant", "className"]);
    var _c;
    return (React.createElement(CompButton, __assign({}, passProps, { className: classnames(className, (_c = {},
            _c[baseClassName + "--" + variant] = variant !== 'default',
            _c[fullWidthClassName] = fullWidth,
            _c)) })));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return baseStyles(props); });
var iconColor = function (_a) {
    var tokens = _a.tokens, invert = _a.invert, disabled = _a.disabled;
    var defaultColor = !!disabled
        ? tokens.colors.depthBase
        : tokens.colors.whiteBase;
    var secondaryColor = !!disabled
        ? tokens.colors.depthBase
        : tokens.colors.highlightBase;
    return !!invert ? secondaryColor : defaultColor;
};
var ButtonWithIcon = (function (_super) {
    __extends(ButtonWithIcon, _super);
    function ButtonWithIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonWithIcon.prototype.render = function () {
        var _a = this.props, icon = _a.icon, iconRight = _a.iconRight, _b = _a.iconProps, iconProps = _b === void 0 ? { className: undefined } : _b, passProps = __rest(_a, ["icon", "iconRight", "iconProps"]);
        var tokens = passProps.tokens, disabled = passProps.disabled, variant = passProps.variant;
        var iconPropsClassName = iconProps.className, passIconProps = __rest(iconProps, ["className"]);
        if (variant === 'unstyled') {
            return React.createElement(UnstyledButton, __assign({}, passProps));
        }
        var secondaryOrTertiary = !!variant &&
            (variant === 'secondary' ||
                variant === 'secondary-noborder' ||
                variant === 'tertiary');
        return (React.createElement(StyledButton, __assign({}, passProps),
            !!icon && (React.createElement(Icon, __assign({ mousePointer: true, icon: icon, color: iconColor({
                    tokens: tokens,
                    disabled: disabled,
                    invert: secondaryOrTertiary,
                }), className: classnames(iconClassName, iconPropsClassName) }, passIconProps))),
            passProps.children,
            !!iconRight && (React.createElement(Icon, __assign({ mousePointer: true, icon: iconRight, color: iconColor({
                    tokens: tokens,
                    disabled: disabled,
                    invert: secondaryOrTertiary,
                }), className: classnames(iconClassName, iconRightClassName, iconPropsClassName) }, passIconProps)))));
    };
    return ButtonWithIcon;
}(Component));
var Button = (function (_super) {
    __extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.render = function () {
        return React.createElement(ButtonWithIcon, __assign({}, withSuomifiDefaultProps(this.props)));
    };
    Button.negative = function (props) {
        return (React.createElement(ButtonWithIcon, __assign({}, withSuomifiDefaultProps(props), { variant: "negative" })));
    };
    Button.secondary = function (props) {
        return (React.createElement(ButtonWithIcon, __assign({}, withSuomifiDefaultProps(props), { variant: "secondary" })));
    };
    Button.secondaryNoborder = function (props) {
        return (React.createElement(ButtonWithIcon, __assign({}, withSuomifiDefaultProps(props), { variant: "secondary-noborder" })));
    };
    Button.tertiary = function (props) {
        return (React.createElement(ButtonWithIcon, __assign({}, withSuomifiDefaultProps(props), { variant: "tertiary" })));
    };
    Button.unstyled = function (props) {
        return React.createElement(UnstyledButton, __assign({}, withSuomifiDefaultProps(props)));
    };
    return Button;
}(Component));
export { Button };
var templateObject_1;
//# sourceMappingURL=Button.js.map